import { createFileRoute, redirect } from '@tanstack/react-router'
import { LIST, restoreFilters } from '@thom/folio-ui/routing/list-filters'
import { DEFAULT_ISSUE_STATUSES } from '@thom/folio-domain/core/domain/issue'
import { Issues } from '@thom/folio-ui/pages/issues'

export const Route = createFileRoute('/_authenticated/$client/$domain/$slug/tickets/')({
	beforeLoad: ({ search, cause, params, context }) => {
		if (cause !== 'enter') return
		const restored = restoreFilters(context.container.listMemory, LIST.TICKETS, search)
		if (restored) throw redirect({ to: '/$client/$domain/$slug/tickets', params, search: restored })
	},
	component: () => <Issues emptyLabel='tickets' defaultStatuses={DEFAULT_ISSUE_STATUSES} />,
})
